import React, {useState, useRef, useEffect} from 'react';
import './nav-bar.scss';
import '../../styles/typography.scss'
import { Link, NavLink, useLocation } from 'react-router-dom';
import DarkModeToggle from '../dark-mode-toggle';
import { useDarkMode } from '../../hooks/useDarkMode';

const NavBar = () => {
  const [menuOpen, setMenuOpen] = useState(false)
  const { isDarkMode, toggleDarkMode } = useDarkMode()
  const location = useLocation()
  const workTabRef = useRef(null)
  const aboutTabRef = useRef(null)
  const underlineRef = useRef(null)
  
  // Function to get the index of the current active tab
  const getActiveTabIndex = () => {
    if (location.pathname === '/' || location.pathname === '/work') return 0
    if (location.pathname === '/about') return 1
    return -1 // For external links like Resume
  }

  const activeTabIndex = getActiveTabIndex()

  // Update underline position when active tab changes
  useEffect(() => {
    if (!underlineRef.current) return

    const updateUnderlinePosition = () => {
      let activeTab = null
      if (activeTabIndex === 0 && workTabRef.current) {
        activeTab = workTabRef.current
      } else if (activeTabIndex === 1 && aboutTabRef.current) {
        activeTab = aboutTabRef.current
      }

      if (activeTab) {
        const tabRect = activeTab.getBoundingClientRect()
        const containerRect = activeTab.parentElement.parentElement.getBoundingClientRect()
        const leftPosition = tabRect.left - containerRect.left + 16 // 16px padding offset
        const width = tabRect.width - 32 // Account for padding

        underlineRef.current.style.transform = `translateX(${leftPosition}px)`
        underlineRef.current.style.width = `${width}px`
        underlineRef.current.style.opacity = '1'
      } else {
        underlineRef.current.style.opacity = '0'
      }
    }

    updateUnderlinePosition()
    
    // Update on window resize to handle responsive changes
    window.addEventListener('resize', updateUnderlinePosition)
    return () => window.removeEventListener('resize', updateUnderlinePosition)
  }, [activeTabIndex])

  return (
    <nav>
      <Link className='title' to="/work">
        <h3>Ravin Perera</h3>
      </Link>
      <div className='menu' onClick={() => setMenuOpen(!menuOpen)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={menuOpen ? "open" : ""}>
        <div ref={underlineRef} className="nav-underline"></div>
        <li>
          <NavLink ref={workTabRef} to="/">Work</NavLink>
        </li>
        <li>
          <NavLink ref={aboutTabRef} to="/about">About</NavLink>
        </li>
        <li>
          <NavLink to="https://drive.google.com/file/d/1RYH37Ryh5T94VMHpztw_mZ0IdL4Ks4s5/view?usp=sharing" target='_blank' rel="noopener noreferrer">Resume</NavLink>
        </li>
        <li>
          <DarkModeToggle isDarkMode={isDarkMode} onToggle={toggleDarkMode} />
        </li>
      </ul>
    </nav>
  );
};

export default NavBar